import { gql } from '@apollo/client';

const PRODUCT_FIELDS = gql`
  fragment ProductFields on Product {
    id
    code
    name
    description
    category_id
    unit_id
    tax_rate_id
    price_cents
    cost_cents
    stock_qty
    stock_min
    is_controlled
    is_exception_handle
    requires_current_weight
    is_batch_tracked
    is_perishable
    is_vaccination_card_product
    partial_kind
    parent_product_id
    parent_factor
    barcode
    branch_id
    status
    created_at
    updated_at
  }
`;

export const PRODUCT_RELATIONS_QUERY = gql`
  query ProductRelations($id: ID!) {
    product(id: $id) {
      id
      code
      name
      partial_kind
      parent_product_id
      parent_factor
      requires_current_weight
      derived_stock_qty
      part_of_kits {
        id
        code
        name
      }
      part_of_services {
        id
        code
        name
      }
      dose_children {
        id
        code
        name
        parent_factor
        derived_stock_qty
      }
    }
  }
`;

export const PRODUCTS_QUERY = gql`
  ${PRODUCT_FIELDS}
  query Products(
    $offset: Int
    $limit: Int
    $search: String
    $status_filter: CatalogStatusFilter
    $category_id: ID
    $low_stock_only: Boolean
  ) {
    products(
      offset: $offset
      limit: $limit
      search: $search
      status_filter: $status_filter
      category_id: $category_id
      low_stock_only: $low_stock_only
    ) {
      items {
        ...ProductFields
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const SET_PRODUCT_STATUS_MUTATION = gql`
  ${PRODUCT_FIELDS}
  mutation SetProductStatus($id: ID!, $status: String!) {
    setProductStatus(id: $id, status: $status) {
      ...ProductFields
    }
  }
`;

export const CREATE_PRODUCT_MUTATION = gql`
  ${PRODUCT_FIELDS}
  mutation CreateProduct($input: CreateProductInput!) {
    createProduct(input: $input) {
      ...ProductFields
    }
  }
`;

export const UPDATE_PRODUCT_MUTATION = gql`
  ${PRODUCT_FIELDS}
  mutation UpdateProduct($id: ID!, $input: UpdateProductInput!) {
    updateProduct(id: $id, input: $input) {
      ...ProductFields
    }
  }
`;
